export default __webpack_public_path__ + "media/components/Courses/Show/Images/disciplines/1-a9b9772cea16dbf49426823640cd669a.svg";